import React from "react";
import { useLazyLoadQuery, graphql } from "react-relay";

import { RuptureSetDiagnosticContainerQuery } from "./__generated__/RuptureSetDiagnosticContainerQuery.graphql";
import { SweepArguments } from "./generalTask.types";
import RuptureSetDiagnosticReportCard from "../../components/ruptureSet/RuptureSetDiagnosticReportCard";

interface RuptureSetDiagnosticContainerProps {
  readonly sweepArgs?: SweepArguments;
  ids?: string[];
}

const RuptureSetDiagnosticContainer: React.FC<RuptureSetDiagnosticContainerProps> = ({
  sweepArgs,
  ids,
}: RuptureSetDiagnosticContainerProps) => {
  const data = useLazyLoadQuery<RuptureSetDiagnosticContainerQuery>(ruptureSetDiagnosticContainerQuery, {
    ids: ids,
  });

  return <RuptureSetDiagnosticReportCard ruptureSets={data} sweepArgs={sweepArgs} />;
};

export default RuptureSetDiagnosticContainer;

export const ruptureSetDiagnosticContainerQuery = graphql`
  query RuptureSetDiagnosticContainerQuery($ids: [ID!]) {
    nodes(id_in: $ids) {
      result {
        edges {
          node {
            __typename
            ... on Node {
              id
            }
            ... on FileInterface {
              file_name
              file_url
              file_size
              md5_digest
              meta {
                k
                v
              }
            }
            ... on RuptureSet {
              created
              fault_models
            }
          }
        }
      }
    }
  }
`;
